import { render } from "./FileTable.vue?vue&type=template&id=7a8531cc&scoped=true"
import script from "./FileTable.vue?vue&type=script&lang=js"
export * from "./FileTable.vue?vue&type=script&lang=js"

import "./FileTable.vue?vue&type=style&index=0&id=7a8531cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8531cc"]])

export default __exports__